import * as React from 'react';
import ColourSwatch, { ColourSwatchProps } from './ColourSwatch';
import '../../styles/components/swatches-group.scss';

export type SwatchesTypes = 'default' | 'colour';

interface SwatchesGroupProps {
    swatches: ColourSwatchProps[];
    option: string;
    index?: number;
    type?: SwatchesTypes
    onSwatchSelected?: (index: number, value: string) => void
}

const SwatchesGroup = (props: SwatchesGroupProps) => {
    const { index, type, onSwatchSelected } = props;
    return (
        <div className={ `swatches-group ${type == 'colour' ? 'swatches-group--colour' : ''}`}>
            <h2 className="swatches-group__title h6">{ props.option }</h2>
            <div className="swatches">
                { props.swatches.map((swatch: ColourSwatchProps) => {
                    return (<ColourSwatch key={swatch.value } {...swatch}></ColourSwatch>)
                })}
            </div>
        </div>
    );
}
export default SwatchesGroup;
